<template>
  <div class="skill_detail">
    <div class="title">
      <el-button
        class="back-btn"
        type="text"
        icon="el-icon-arrow-left"
        @click="$router.go(-1)"
        >返回</el-button
      >
      <b>技能考核</b>
      <div class="btn student_btn">
        <el-select
          v-model="params.userId"
          placeholder="请选择学生"
          size="mini"
          @change="getList"
        >
          <el-option
            v-for="item in studentList"
            :key="item.userId"
            :label="item.name"
            :value="item.userId"
          >
          </el-option>
        </el-select>
      </div>
      <div class="btn chapter_btn">
        <el-cascader
          v-model="params.classChapterId"
          @change="getList"
          :options="chapters"
          :props="{
            label: 'title',
            value: 'classChapterId',
            emitPath: false,
          }"
          :show-all-levels="false"
          size="mini"
          placeholder="请选择章节"
        ></el-cascader>
        <!-- <el-select
          v-model="classChapterId"
          placeholder="请选择章节"
          size="mini"
          @change="getList"
        >
          <el-option-group
            v-for="group in chapters"
            :key="group.classChapterId"
            :label="group.title"
          >
            <el-option
              v-for="item in group.children"
              :key="item.classChapterId"
              :label="item.title"
              :value="item.classChapterId"
            >
            </el-option>
          </el-option-group>
        </el-select> -->
      </div>
      <!-- <div class="btn export_btn">
        导出数据 <i class="el-icon-arrow-right"></i>
      </div> -->
    </div>
    <div class="main">
      <div class="box_title">作品</div>
      <div class="works_box" v-if="total > 0">
        <div class="one_work" v-for="item in workList" :key="item.id">
          <el-image
            class="avatar"
            :src="item.worksType == 'TEAM' ? item.teamIcon : item.avatar"
            fit="cover"
          ></el-image>
          <div class="right_content">
            <div class="work">
              <p class="name">
                {{ item.worksType == "TEAM" ? item.teamName : item.nickName }}
                <el-tag size="mini" effect="dark" style="margin-left: 20px">{{
                  item.worksType == "TEAM" ? "团队作品" : "个人作品"
                }}</el-tag>
                <el-tag
                  v-show="item.great"
                  size="mini"
                  effect="dark"
                  type="danger"
                  style="margin-left: 10px"
                  >优秀</el-tag
                >
                <el-tag
                  v-show="item.typical"
                  size="mini"
                  effect="dark"
                  type="warning"
                  style="margin-left: 10px"
                  >典型</el-tag
                >
              </p>
              <p class="text_content" v-if="item.info">
                {{ item.info }}
              </p>
              <div class="media_content">
                <div
                  class="one_media"
                  v-for="t in item.showFiles"
                  :key="t.worksFileId"
                >
                  <video
                    v-if="t.type == 'mp4'"
                    :src="t.url"
                    controls="controls"
                  ></video>

                  <el-image
                    style="width: 100%; height: 100%"
                    v-else
                    :src="t.url"
                    :preview-src-list="getImgList(t)"
                  >
                  </el-image>
                </div>
                <div
                  class="other-type"
                  v-for="t in item.otherFiles"
                  :key="t.worksFileId"
                >
                  <i class="el-icon-document"></i>
                  <a :href="t.url" target="_blank" title="点击下载" download>{{
                    t.fileName
                  }}</a>
                </div>
              </div>
              <div class="bottom_row clearfix">
                <span class="chapter_name"
                  >{{ item.chapterName }} —
                  {{ item.taskId == 0 ? "默认实战" : item.taskTitle }}</span
                >
                <span class="time">{{
                  formatDate(item.createTime, "YYYY-MM-DD HH:mm:ss")
                }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="foot_page">
          <el-pagination
            background
            layout="prev, pager, next, jumper"
            :page-size="params.limit"
            :current-page.sync="params.page"
            :total="total"
            @current-change="getList"
          >
          </el-pagination>
        </div>
      </div>
      <el-empty description="暂无作品" v-else></el-empty>
    </div>
  </div>
</template>

<script>
import { chapterList } from "@/api/chapter";
import { worksList } from "@/api/works";
import { formatDate, handleTree } from "@/utils/index";

export default {
  data() {
    return {
      formatDate,
      chapters: [],
      params: {
        page: 1,
        limit: 10,
        classChapterId: Number(this.$route.query.classChapterId),
        userId: Number(this.$route.query.userId),
      },
      total: 0,
      workList: [],
    };
  },
  created() {
    this.getChapterList();
    this.getList();
  },
  computed: {
    studentList() {
      return this.$store.state.studentList;
    },
  },
  methods: {
    // 章节列表
    getChapterList() {
      chapterList({ classId: this.$route.query.id }).then((res) => {
        if (res.code == 0) {
          //   console.log(res);
          let chapters = handleTree(res.data, "chapterId");

          chapters.forEach((item) => {
            if (item.children) {
              // 二级目录
              let secondArr = item.children;
              secondArr.forEach((s) => {
                if (s.children) {
                  // 三级目录为底层
                  let thirdArr = s.children;
                  let flag = thirdArr.every((t) => !t.complete);
                  if (flag) {
                    // 三级目录里全部未生成成绩
                    secondArr = secondArr.filter(
                      (n) => n.chapterId != s.chapterId
                    );
                  } else {
                    // 三级目录筛选
                    thirdArr.forEach((t) => {
                      if (!t.complete) {
                        thirdArr = thirdArr.filter(
                          (n) => n.chapterId != t.chapterId
                        );
                      }
                    });
                  }
                } else {
                  // 二级目录为底层
                  if (!s.complete) {
                    secondArr = secondArr.filter(
                      (n) => n.chapterId != s.chapterId
                    );
                  }
                }
              });
              // 一级目录的children赋值
              if (secondArr.length > 0) {
                item.children = secondArr;
              } else {
                delete item.children;
              }
            }
          });
          // 筛选掉一级目录中无children的，生成最终目录
          this.chapters = chapters.filter((item) => item.children);
        } else {
          console.log(res.msg);
        }
      });
    },
    // 作品列表
    getList() {
      if (this.$route.query.classChapterId) this.$loading.show();
      worksList(this.params).then((res) => {
        this.$loading.hide();
        if (res.code == 0) {
          // console.log(res);
          res.data.records.forEach((item) => {
            item.showFiles = [];
            item.otherFiles = [];
            item.fileList.forEach((file) => {
              if (
                file.type != "mp4" &&
                file.type != "png" &&
                file.type != "jpg" &&
                file.type != "jpeg" &&
                file.type != "gif"
              ) {
                item.otherFiles.push(file);
              } else {
                item.showFiles.push(file);
              }
            });
          });
          this.workList = res.data.records;
          this.total = res.data.total;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    getImgList(t) {
      let images = [];
      images.push(t.url);
      return images;
    },
    format(percentage) {
      return percentage;
    },
  },
};
</script>

<style lang="less" scoped>
.skill_detail {
  height: 748px;
  background-image: url("../../../../assets/images/evaluation_bg.png");
  background-size: cover;
  .title {
    position: relative;
    padding-top: 40px;
    height: 105px;
    text-align: center;
    background-image: url("../../../../assets/images/title_bg1.png");
    background-size: cover;
    .back-btn {
      position: absolute;
      left: 20px;
      top: 13px;
    }
    b {
      letter-spacing: 5px;
      font-size: 30px;
      color: transparent;
      background-image: linear-gradient(180deg, #fff, #fff, #1de0fe, #1de0fe);
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
    .btn {
      position: absolute;
      top: 62px;
      width: 114px;
      height: 32px;
      line-height: 32px;
      color: #fff;
      background-image: url("../../../../assets/images/btn_bg.png");
      cursor: pointer;
      &.export_btn {
        right: 0;
      }
      &.student_btn {
        left: 0;
        ::v-deep .el-select {
          .el-input__inner {
            padding-left: 15px;
          }
          .el-input__suffix {
            right: 6px;
          }
        }
      }
      &.chapter_btn {
        left: 126px;
        ::v-deep .el-select,
        ::v-deep .el-cascader {
          .el-input__inner {
            padding-left: 15px;
          }
          .el-input__suffix {
            right: 6px;
          }
        }
      }
      ::v-deep .el-select,
      ::v-deep .el-cascader {
        .el-input__inner {
          padding-left: 20px;
          font-size: 14px;
          color: #fff;
          background-color: transparent;
          border: none;
        }
        .el-input__suffix {
          right: 10px;
          .el-select__caret {
            color: #fff;
          }
        }
      }
    }
  }
  .main {
    margin: 20px 0 0;
    height: 100%;
    .box_title {
      padding: 0 10px;
      height: 48px;
      line-height: 48px;
      font-size: 16px;
      color: #1de0fe;
      background-color: rgba(49, 70, 125, 0.1);
      // border: solid 1px rgba(4, 20, 40, 0.1);
      box-shadow: #6be4f7 0px 0px 5px inset;
    }
    .works_box {
      padding: 20px;
      height: calc(100% - 173px);
      overflow-y: auto;
      &::-webkit-scrollbar {
        width: 6px;
        background-color: rgb(14, 88, 113);
      }

      &::-webkit-scrollbar-track {
        box-shadow: inset 0 0 6px rgba(14, 88, 113, 0.3);
        -webkit-box-shadow: inset 0 0 6px rgba(14, 88, 113, 0.3);
        background-color: rgb(14, 88, 113);
      }

      &::-webkit-scrollbar-thumb {
        box-shadow: inset 0 0 6px rgba(27, 213, 246, 0.1);
        -webkit-box-shadow: inset 0 0 6px rgba(27, 213, 246, 0.1);
        background-color: #1ae0fe;
      }
      .one_work {
        margin-bottom: 18px;
        text-align: left;
        .avatar {
          margin-right: 20px;
          width: 64px;
          height: 64px;
          border-radius: 5px;
          vertical-align: top;
        }

        .right_content {
          display: inline-block;
          width: calc(100% - 64px - 20px);
          border-bottom: solid 1px transparent;
          border-image: linear-gradient(to right, #1de0fe, transparent) 1 10;
          .work {
            .name {
              font-size: 16px;
              color: #1890ff;
            }

            .text_content {
              margin-top: 15px;
              color: #feffff;
              font-size: 16px;
            }

            .media_content {
              margin-top: 15px;
              .one_media {
                display: inline-block;
                margin-right: 7px;
                width: 200px;
                height: 200px;
                border-radius: 5px;
                overflow: hidden;

                img,
                video {
                  width: 100%;
                  height: 100%;
                  background-color: rgba(0, 0, 0, 0.4);
                }
              }
              .other-type {
                margin-top: 10px;
                color: #feffff;
                font-size: 16px;
                a {
                  margin-left: 5px;
                  &:hover {
                    text-decoration: underline;
                  }
                }
              }
            }

            .bottom_row {
              margin: 10px 0;

              .chapter_name,
              .time {
                color: #c8c8c8;
                font-size: 14px;

                &.chapter_name {
                  margin-right: 20px;
                }
              }
            }
          }
        }
      }

      ::v-deep .foot_page {
        margin-top: 20px;
        text-align: right;

        .el-pagination.is-background .el-pager li:not(.disabled).active {
          background-color: teal;
        }

        .el-pagination__total {
          float: left;
        }
      }
    }
  }
}
</style>